import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store/state";
import { ResponseModel } from "../models/common/ResponseModel";
import { AxiosError } from "axios";
import { ARIA_SuccessCode, GetComponentsResponseModel } from "models";
import { getComponentListAPI } from "services/componentServices";

const initialState: RootState.ComponentState = {
  componentList: [],
  error: undefined,
  isLoading: false,
};

//Actions
//More info here https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchComponentList = createAsyncThunk<
  GetComponentsResponseModel,
  void,
  { rejectValue: AxiosError<Error> }
>("component/getComponentList", async (_, thunkApi) => {
  try {
    var pageIndex = 1;

    let data: GetComponentsResponseModel =
      await getComponentListAPI({ pageIndex });

    let tempData = data.result.items;

    while (data.result.pageCount > pageIndex) {
      pageIndex++;
      let nextData: GetComponentsResponseModel =
        await getComponentListAPI({ pageIndex });

      tempData.push(...nextData.result.items);
    }

    data.result.items = tempData;

    return data;
  } catch (err) {
    let error = err as AxiosError<Error>; // cast the error for access
    if (!error.response) {
      throw err;
    }
    // We got validation errors, let's return those so we can reference in our component and set form errors
    return thunkApi.rejectWithValue(error);
  }
});

//Slice
//More info here https://redux-toolkit.js.org/api/createSlice
export const componentSlice = createSlice({
  name: "component",
  initialState,
  reducers: {
    //local reducer
    resetComponentState() {
      return initialState;
    },
  },
  //services reducers
  extraReducers: (builder) => {
    builder.addCase(
      fetchComponentList.fulfilled,
      (state, { payload }) => {
        if (payload.resultCode === ARIA_SuccessCode) {
          state.componentList = payload.result.items;
          state.error = undefined;
        } else {
          state.error = { ...payload };
        }

        state.error = undefined;
        state.isLoading = false;
      }
    ),
      builder.addCase(fetchComponentList.pending, (state, _) => {
        state.isLoading = true;
      }),
      builder.addCase(
        fetchComponentList.rejected,
        (state, action) => {
          if (action.payload != undefined) {
            let error: AxiosError<Error> = action.payload;

            const serverError: ResponseModel = {
              resultCode: error?.response?.status.toString() ?? "",
              resultDescription: error?.response?.data.message ?? "",
            };

            state.error = serverError;
            state.isLoading = false;
          }
        }
      );
  },
});

export const { resetComponentState } = componentSlice.actions;

export default componentSlice.reducer;
